import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { getStorage, STORAGE_KEY } from '../helpers/storage';

// Get saved language from localStorage
const savedLanguage = getStorage(STORAGE_KEY.I18_NEXT_LANGUAGE) || 'en';

i18n
  .use(Backend)
  // .use(LanguageDetector) // Remove if using locales from Keycloak
  .use(initReactI18next)
  .init({
    // debug: process.env.NODE_ENV === 'development',
    lng: savedLanguage,
    fallbackLng: {
      'en-US': ['en'],
      en: ['en'],
      ja: ['ja'],
      ar: ['ar'],
      de: ['de'],
      es: ['es'],
      fr: ['fr'],
      hi: ['hi'],
      ko: ['ko'],
      nl: ['nl'],
      pt: ['pt'],
      vi: ['vi'],
      zh: ['zh'],
      'zh-CN': ['zh'],
      default: ['en'],
      'pt-BR': ['pt'],
    },
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    // detection: {
    //   // Remove all if using locales from Keycloak
    //   order: ['localStorage', 'navigator'],
    //   caches: ['localStorage'],
    // },
    react: {
      useSuspense: false,
    },
  })
  .catch((err) => {
    console.error('i18n initialization failed:', err);
  });

export default i18n;
